export default {
  setDataLoaded: 'UI_MUTATIONS_SET_DATA_LOADED',
  setIsLoadingMoreDataPast: 'UI_MUTATIONS_SET_IS_LOADING_MORE_DATA_PAST',
  setIsLoadingMoreDataFuture: 'UI_MUTATIONS_SET_IS_LOADING_MORE_DATA_FUTURE',
  setCalendarCollapsed: 'UI_MUTATIONS_SET_CALENDAR_COLLAPSED',
  setSelectedDate: 'UI_MUTATIONS_SET_SELECTED_DATE'
}
